import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Replace_record extends PureComponent {
  render() {
    return (
      <div className="row" id="replace_record">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Replace Record</h2>
              <p>
                The Replace Record function replaces the entire contents of a
                record with the exception of the "object_created_by" field.
                Permissions, record audits and workflows treat a record replace
                the same as a record update. The record audit logs will not be
                removed.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Replace Record Example</h2>
              <p>
                In this example all the record contents of ID 454 will be
                replaced with text_name "George" and long_length 90.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePUT">PUT</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"George"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_length"</span>: 90
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"id"</span>:{" "}
                  <span className="jsonY">"453"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"George"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_length"</span>:{" "}
                  <span className="jsonP">90</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"object_created_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"Betty"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Graham"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"BETH"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-07T12:01:49.524Z"</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"object_updated_by"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"JOHN"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"date_created"</span>:{" "}
                  <span className="jsonY">"2016-03-09T15:09:24.850Z"</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Replace_record;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Replace_record.js